
import React, { useState, useEffect } from "react";
import {
  TextField, Button, Grid, Typography, FormControl, MenuItem, Select, InputLabel
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useParams } from "react-router-dom";
import ShowTimeServices from "../../services/externalServices/TicketServices/showTimeServices";
import TheatreServices from "../../services/externalServices/TicketServices/theatreServices";

const UpdateShowtimes = () => {
  const { id: showtimeId } = useParams(); // Get showtimeId from URL parameters
  const [showtimeData, setShowtimeData] = useState({
    validityFrom: null,
    validityUntil: null,
    theatreDetails: [], // Array of objects with theatre details and showtimes
    movieId: "",
  });

  const [theatres, setTheatres] = useState([]);

  useEffect(() => {
    const fetchTheatres = async () => {
      try {
        const response = await TheatreServices.getTheatres();
        setTheatres(response);
      } catch (error) {
        console.error("Error fetching theaters:", error);
      }
    };

    const fetchShowtimeData = async () => {
      try {
        const response = await ShowTimeServices.getShowtimeById(showtimeId);
        console.log("fetchShowtimeData response:", response); // Log the response for debugging

        // Add defensive checks to avoid errors
        if (response) {
          const { validityFrom, validityUntil, theatreDetails, movieId } = response;
          setShowtimeData({
            validityFrom: validityFrom ? new Date(validityFrom) : null,
            validityUntil: validityUntil ? new Date(validityUntil) : null,
            theatreDetails: theatreDetails || [], // Ensure theatreDetails is an array
            movieId: movieId ? movieId._id : "" // Ensure movieId is properly set
          });
        }
      } catch (error) {
        console.error("Error fetching showtime data:", error);
      }
    };

    fetchTheatres();
    fetchShowtimeData();
  }, [showtimeId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setShowtimeData({
      ...showtimeData,
      [name]: value,
    });
  };

  const handleShowTimesChange = (e, index) => {
    const { value } = e.target;
    const updatedShowTimes = [...showtimeData.theatreDetails];
    updatedShowTimes[index].showTimes = value.split(",").map(item => item.trim());
    setShowtimeData({
      ...showtimeData,
      theatreDetails: updatedShowTimes,
    });
  };

  const handleTheatreChange = (event, index) => {
    const { value } = event.target;
    const updatedTheatreDetails = [...showtimeData.theatreDetails];
    updatedTheatreDetails[index].theatreId = { _id: value }; // Set the selected theatreId
    setShowtimeData({
      ...showtimeData,
      theatreDetails: updatedTheatreDetails,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Prepare data for update
      const updatedData = {
        movieId: showtimeData.movieId,
        theatreDetails: showtimeData.theatreDetails.map(detail => ({
          theatreId: detail.theatreId._id, // Use theatreId directly
          showTimes: detail.showTimes,
        })),
        validityFrom: showtimeData.validityFrom ? showtimeData.validityFrom.toISOString() : null,
        validityUntil: showtimeData.validityUntil ? showtimeData.validityUntil.toISOString() : null,
      };

      await ShowTimeServices.updateShowTime(showtimeId, updatedData);
      console.log("Showtime updated:", updatedData);
    } catch (error) {
      console.error("Error updating showtime:", error);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4">Update Showtime</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Theatres</InputLabel>
              <Select
                multiple
                value={showtimeData.theatreDetails.map(detail => detail.theatreId._id)}
                onChange={(e) => handleTheatreChange(e, 0)} // Handle change for the first theatre for example
                fullWidth
              >
                {theatres.map((theatre) => (
                  <MenuItem key={theatre._id} value={theatre._id}>
                    {theatre.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Validity From"
                value={showtimeData.validityFrom}
                onChange={(date) => setShowtimeData({ ...showtimeData, validityFrom: date })}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Validity Until"
                value={showtimeData.validityUntil}
                onChange={(date) => setShowtimeData({ ...showtimeData, validityUntil: date })}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
         {showtimeData.theatreDetails.map((detail, index) => {
  // Compute the label dynamically
  const theatreName = theatres.find(t => t._id === detail.theatreId._id)?.name || "Theatre";
  const label = `Show Times for ${theatreName}`;

  return (
    <Grid item xs={12} key={index}>
      <FormControl fullWidth>
        <TextField
          label={label}
          value={detail.showTimes.join(", ")}
          onChange={(e) => handleShowTimesChange(e, index)}
          fullWidth
        />
      </FormControl>
    </Grid>
  );
})}
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Update Showtime
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default UpdateShowtimes;


